/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(
	Class
) {
	'use strict';

	var BaseTask = Class.extend({

		init: function(options) {
			BaseTask.inherited('init', this, arguments);

			this.id = options.id;
			this.owner = options.owner;
			this.ownerWidget = options.ownerWidget;
			this.logger = options.logger;
			this.visAPI = options.visAPI;
			this.dashboardApi = options.dashboardApi;
			this.content = options.content;

			this._initializeStep = this.owner._initializeStep.bind(this.owner);
			this._isStepComplete = this.owner._isStepComplete.bind(this.owner);
			this._completeStep = this.owner._completeStep.bind(this.owner);
			this._logRenderContext = this.owner._logRenderContext.bind(this.owner);

			if (this.id) {
				this._initializeStep(this.id);
			}
		},

		getId: function() {
			return this.id;
		},

		getRenderState: function() {
			return this.owner._renderState;
		},

		clearError: function() {
			const state = this.content.getFeature('state.internal');
			if (state) {
				state.clearError();
			}
		},

		/**
		 * does nothing: the error is shown in VisRenderSequence
		 */
		showError: function() {
		},

		/**
		 * Process the task
		 * @param renderContext - the render context
		 * @returns a promise
		 */
		process: function(/*renderContext*/) {
			return Promise.reject(new Error('BaseTask.process needs to be overridden!'));
		}
	});

	return BaseTask;
});
